<template>
  <v-select class="service-code"
            v-model="selectedValue"
            :options="staffRoles"
            label="display_name"
            style="width: 200px;"
            @input="onChange"
            @update:modelValue="onChange">
  </v-select>
</template>

<script>
import { ref, watch, defineComponent, onMounted } from 'vue'
import _ from 'underscore'

export default defineComponent({
  name: 'SelectStaffRole',
  props: {
    modelValue: {
      type: [Number, String, null],
      default: null
    }
  },
  emits: ['update:modelValue', 'change'],
  setup (props, { emit }) {
    const staffRoles = ref([
      {
        id: 1,
        display_name: '管理者'
      },
      {
        id: 2,
        display_name: 'サ責'
      },
      {
        id: 3,
        display_name: 'ヘルパー'
      }
    ])

    const selectedValue = ref(null)

    watch(() => props.modelValue, (newValue) => {
      if (newValue) {
        selectedValue.value = _.find(staffRoles.value, role => role.id === Number(newValue))
      } else {
        selectedValue.value = null
      }
    }, { immediate: true })

    const onChange = (newValue) => {
      const newId = newValue ? newValue.id : null
      emit('update:modelValue', newId)
    }

    onMounted(() => {
      if (props.modelValue) {
        selectedValue.value = _.find(staffRoles.value, role => role.id === Number(props.modelValue))
      }
    })

    return {
      staffRoles,
      selectedValue,
      onChange
    }
  }
})
</script>

<style scoped>
</style>
